export default "__VITE_ASSET__395d36f8__"